export default {
    accountSetting: 'Account Setting',
    cancel: 'Cancel',
    save: 'Save',
    profile: 'Profile',
    edit: 'EDIT',
    employeeID: 'Employee ID',
    phoneNumber: 'Phone Number',
    name: 'Name',
    surname: 'Surname',
    username: 'Username',
    emailAddress: 'Email address',
    resetPassword: 'Reset password',
    oldPassword: 'Old password',
    enterYourOldPassword: 'Enter your Old password',
    newPassword: 'New password',
    enterYourNewPassword: 'Enter your new password',
    confirmPassword: 'Confirm password',
    confirmYourNewPassword: 'Confirm your new password',
    fieldRequest: 'Field request',
    updateAccountInformation: 'Update account information',
    successfully: 'successfully',
    emailRequired: 'Enter email address',
    emailFormatMustBeValid: 'E-mail format must be valid',
    currentPasswordRequired: 'Current password is required',
    newPasswordRequired: 'New password is required',
    confirmPasswordRequired: 'Confirm your new password',
    confirmPasswordShouldBeSame: 'Confirm password should be same',
    enterName: 'Enter Name',
    enterSurame: 'Enter Surname',
    enterPhonenumber: 'Enter Phone number'
}
